import type { UseQueryResult } from "@tanstack/react-query"
import { useQuery } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import type { BatteryProposalGenabilityAccountDto } from "../dto/battery-proposal.dto"
import { batteryProposalService } from "../services/battery-proposal.service"

/**
 * Ensures the Site's Genability account and reads its tariff candidates.
 *
 * The endpoint writes, but the setup form wants it on display rather than on an
 * interaction, so it is a query: React Query holds one request per proposal, and
 * a second mount while the first is in flight joins it instead of racing it.
 */
export default function useBatteryProposalGenabilityAccount(
  proposalId: string,
): UseQueryResult<BatteryProposalGenabilityAccountDto, unknown> {
  return useQuery({
    queryKey: queryKeys.batteryProposal.genabilityAccount(proposalId),
    queryFn: () => batteryProposalService.ensureGenabilityAccount(proposalId),
    enabled: !!proposalId,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  })
}
